import { render, staticRenderFns } from "./ModalRegisterClient.vue?vue&type=template&id=7e0cbcba&scoped=true&"
import script from "./ModalRegisterClient.vue?vue&type=script&lang=js&"
export * from "./ModalRegisterClient.vue?vue&type=script&lang=js&"
import style0 from "./ModalRegisterClient.vue?vue&type=style&index=0&id=7e0cbcba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0cbcba",
  null
  
)

export default component.exports